export const lgtmValidate = objectValidator => objectToValidate => new Promise((resolve, reject) => objectValidator.validate(objectToValidate, function (err, value) {
  if (err != null) {
    reject(err);
    return;
  }
  resolve(value);
}));